import {Component, Input} from "@angular/core";
import {Subscription} from "../../../core/models/subscription.model";
import { Addon } from "../../../core/models/addon.model";
import { Coupon } from "../../../core/models/coupon.model";

@Component({
  selector: 'app-onboarding-summary',
  templateUrl: './onboarding-summary.component.html',
  styleUrls: ['./onboarding-summary.component.scss']
})
export class OnboardingSummaryComponent {
  private readonly _VAT_RATE = 0.2; // 20% VAT rate

  private _subscription!: Subscription | null;
  private _coupon: Coupon | null = null;
  private _showAllInfo!: boolean;


  get subscription(): Subscription | null {
    return this._subscription;
  }

  @Input({ required: true })
  set subscription(value: Subscription | null) {
    this._subscription = value;
  }

  get coupon(): Coupon | null {
    return this._coupon;
  }

  @Input({ required: true })
  set coupon(value: Coupon | null) {
    this._coupon = value;
  }

  get showAllInfo(): boolean {
    return this._showAllInfo;
  }

  @Input({ required: true })
  set showAllInfo(value: boolean) {
    this._showAllInfo = value;
  }

  public getTotalWithTaxes(): number {
    let total: number = 0; // we don't pay the subscription at first, it comes via subscription

    this.subscription?.addons.forEach(addon => {
      total += this._coupon ? this.getAddonDiscountedPrice(addon) : addon.basePrice;
    });

    return +total.toFixed(2);
  }

  public getTotalAmountWithoutTaxes(): number {
    let totalWithVat = 0;
    let totalNoVat = 0;

    this.subscription?.addons.forEach(addon => {
      if (addon.hasVat) {
        totalWithVat += this._coupon ? this.getAddonDiscountedPrice(addon) : addon.basePrice;
      } else {
        totalNoVat += this._coupon ? this.getAddonDiscountedPrice(addon) : addon.basePrice;
      }
    });

    const total = totalNoVat + (totalWithVat / (1 + this._VAT_RATE));

    return +total.toFixed(2);

  }

  public getTotalTaxes(): number {
    return this.getTotalWithTaxes() - this.getTotalAmountWithoutTaxes();
  }

  public getSubscriptionDiscountedPrice(): number {
    if (!this.subscription) return 0;

    const basePrice = this.subscription.basePrice;

    if (this._coupon?.reduction) {
      const reductionPercent = parseFloat(this._coupon.reduction);
      return Math.max(0, basePrice * (1 - reductionPercent / 100));
    }

    return basePrice;
  }

  public getAddonDiscountedPrice(addon: Addon): number {
    const basePrice = addon.basePrice;

    const matched = this._coupon?.couponAddons?.find(a => a.addonId === addon.id);
    if (matched) {
      return Math.max(0, basePrice * (1 - matched.reduction / 100));
    }

    return basePrice;
  }

  public hasCouponForAddon(addon: Addon): boolean {
    return this._coupon?.couponAddons?.some(ca => ca.addonId === addon.id) ?? false;
  }
}
